import React from "react";
import EventList from "./EventList";

const EventsPage: React.FC = () => {
  return <EventList />;
};

export default EventsPage;
